'use client'

import cx from 'classnames'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'

import RequiredLabel from '@/components/Form/Atoms/RequiredLabel'
import { SurveyQuestionType } from '@/types/surveyQuestion'

export type Props = {
  surveyAnswersKeyName: string
  surveyQuestion: SurveyQuestionType
  index: number | null
}

export default function SurveyFormCheckbox({ surveyAnswersKeyName, surveyQuestion, index }: Props) {
  const { watch, register } = useFormContext()

  const watchValue = watch(surveyAnswersKeyName)

  return (
    <div className={cx('c-surveyForm-surveyForm__questions')}>
      <label className="c-inputBase__label u-mb14">
        <span>
          {index !== null && <span>{index + 1}. </span>}
          {surveyQuestion.name}
          {surveyQuestion.answerRequired && <RequiredLabel />}
        </span>
      </label>

      <div className={cx('c-surveyForm-surveyForm__questions-checkbox')}>
        {surveyQuestion.surveyOptions.map((surveyOption) => {
          return (
            <Fragment key={surveyOption.surveyOptionId}>
              <label
                htmlFor={surveyOption.surveyOptionId}
                className={cx('c-surveyForm-surveyForm__questions-checkbox-label', {
                  // @ts-ignore
                  'c-surveyForm-surveyForm__questions-checkbox-label--checked': (
                    watchValue[surveyQuestion.surveyQuestionId] || []
                  ).includes(surveyOption.surveyOptionId),
                })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  fill="none"
                  opacity="1"
                  style={{ width: '20px', height: '20px' }}
                >
                  <rect x="0" y="0" width="65" height="65" stroke="#060725" fill="transparent" strokeWidth="1" />
                  {(watchValue[surveyQuestion.surveyQuestionId] || []).includes(surveyOption.surveyOptionId) ? (
                    <path
                      d="M20 30 L30 40 L50 20"
                      stroke="#060725"
                      strokeWidth="8"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  ) : (
                    <></>
                  )}
                </svg>
                <input
                  id={surveyOption.surveyOptionId}
                  type="checkbox"
                  value={surveyOption.surveyOptionId}
                  {...register(`${surveyAnswersKeyName}.${surveyQuestion.surveyQuestionId}`)}
                />
                <span>{surveyOption.name}</span>
              </label>
            </Fragment>
          )
        })}
      </div>
      <p className={cx('u-help', 'u-mb10', 'c-surveyForm-surveyForm__help')}>※ 複数回答可能</p>
    </div>
  )
}
